<template>
  <v-app>
    <!-- <v-toolbar flat style="background-color: #F6F6F6" height="90">
               <v-spacer></v-spacer>
               <img class="mr-2" src="../assets/header-logo.svg" height="70"/>
           </v-toolbar> -->

    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ loadingMessage }}
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog
    >
    <!--Start: System bar if subscription has been cancelled--->
    <v-system-bar v-if="businessProfile.cancelAtPeriodEnd == true" app fixed color="#CFE2E4"
                  class="justify-center align-center"
                  height="40"
    >
      <div class="d-flex justify-center align-center system-bar-canceled-subscription">
        
             <span class="material-symbols-outlined warning-icon-size">
              warning
            </span>
        <span class="font-weight-bold ml-3"> Your subscription has been cancelled and you will no longer be able to access the Business Portal after {{ businessProfile.currentPeriodEnd.toDate().toLocaleDateString() }}</span>
        <v-btn small class="primary ml-3" depressed @click="restartSubscription">Restart now</v-btn>
      </div>
    </v-system-bar>
    <!--End: System bar if subscription has been cancelled--->

    <!--Start: System bar if subscription is overdue--->
    <v-system-bar v-if="businessProfile.subscriptionStatus == 'past_due'" app fixed
                  class="justify-center align-center black--text" color="#ffd64e"
                  height="40"
    >
      <div class="d-flex justify-center align-center">
            <span class="material-symbols-outlined warning-icon-size">
              warning
            </span>
        <span class="ml-3 charcoal-grey-text">Your subscription is overdue. Update your payment method to continue enjoying uninterrupted access</span>
        <v-btn small color="#212121" class=" ml-3" depressed outlined @click="showUpdatePaymentMethodDialog = true">
          Update payment method
        </v-btn>
      </div>
    </v-system-bar>
    <!--End: System bar if subscription is overdue--->
    <v-navigation-drawer clipped app v-model="drawer">
      <!-- <v-layout column align-center>
            <v-flex class="mt-4">
                <v-avatar color="primary" size=60 :style="`background-position: center;background-repeat: no-repeat;background-size: cover;background-size: cover;background-image: url('${businessProfile.premiereProfileLogoImageURL || ''}')`">
                <v-icon v-if="(businessProfile.premiereProfileLogoImageURL || '') ==''" dark size=30>person</v-icon>
                </v-avatar>
            </v-flex>
            <v-flex class="mt-1">
                <span class="subheading mt-1 dark" >{{ userProfile.firstName + " " + userProfile.lastName }}</span>
            </v-flex>
            <v-flex>
                <span class="grey--text caption">{{businessProfile.businessName}}</span>
            </v-flex>
        </v-layout> -->
      <v-list dense nav class="mt-2" :class="!isDarkModeActivated ? 'primary--text' : 'primary--text'">
        <!-- <v-divider class="my-2"></v-divider> -->
        <v-list-item v-for="item in items" :key="item.title" router :to="item.link">
          <v-list-item-icon>
            <v-icon :disabled="businessProfile.plan != 'evolve' && item.title == 'EventConnect'">{{
                item.icon
              }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-badge
                :content="businessPortalStats.noOfNewNotifications"
                :value="businessPortalStats.noOfNewNotifications"
                inline
                v-if="item.title == 'Notifications'"
            >
              <v-list-item-title class="font-weight-regular">{{ item.title }}</v-list-item-title>
            </v-badge>
            <!-- <v-badge content="Coming soon" inline v-else-if="item.title == '''Multi Conn''ect'">
              <v-list-item-title class="font-weight-regular">{{ item.title }}</v-list-item-title>
            </v-badge> -->
            <v-list-item-title
                :class="[{'grey--text': businessProfile.plan != 'evolve' && item.title == 'EventConnect'},'font-weight-regular']"
                v-else>{{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item link @click.stop="logoutConfirmationDialog = true">
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-regular">Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <template v-if="!isPartnerRepresentative()">
          <v-subheader class="text-body">Optional Inclusions</v-subheader>
          <v-list-item v-for="item in optionalInclusions" :key="item.title" router :to="item.link">
            <v-list-item-icon>
              <v-icon v-if="item.title != 'EventConnect'">{{ item.icon }}</v-icon>
              <v-img v-else :disabled="businessProfile.plan != 'evolve' && item.title == 'EventConnect'"
                     src="@/assets/icons/multi-connect-icon.png" height="25" width="25"></v-img>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-if="item.title == 'EventConnect'"
                                 :class="[{'grey--text': businessProfile.plan != 'evolve'},'font-weight-regular']">
                {{ item.title }}
              </v-list-item-title>
              <v-list-item-title v-else
                                 :class="[{'grey--text': !businessProfile.hasRequestedCRMIntegration },'font-weight-regular']">
                {{ item.title }}
              </v-list-item-title>

            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-list dense nav :class="!isDarkModeActivated ? 'primary--text' : 'primary--text'">
            <v-divider class="my-2"></v-divider>
            <v-list-item @click="openSupportUrl">
              <v-list-item-icon>
                <v-icon>help</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-regular">Support</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        :color="isDarkModeActivated? '' : 'secondary'"
        dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
          style="width: 300px"
          class="ml-0 pl-4"
      >
        <!-- <span class="hidden-sm-and-down">Pappyon</span> -->
        <a href="https://pappyon.com/">
          <img class="mr-2" src="../assets/whitePappyonLogo.png" height="32"/>
        </a>
      </v-toolbar-title>
      <!-- <v-text-field
      flat
      solo-inverted
      hide-details
      prepend-inner-icon="mdi-magnify"
      label="Search"
      class="hidden-sm-and-down"
      ></v-text-field> -->
      <v-spacer></v-spacer>

      <v-menu offset-y v-model="businessProfilesMenu" transition="slide-y-transition" content-class="mt-2">
        <template #activator="{ on: onMenu }">
          <v-tooltip bottom>
            <template #activator="{ on: onTooltip }">
              <v-btn v-on="{ ...onMenu, ...onTooltip }" icon class="mr-2" active-class="no-active">
                <v-icon>mdi-briefcase</v-icon>
              </v-btn>
            </template>
            <span>Business Profiles</span>
          </v-tooltip>
        </template>
        <v-card min-width="275" class="overflow-y-auto" max-height="500px">
          <v-list nav class="overflow-y-auto" max-height="430px">
            <v-list-item>
              <UserAvatar :usersInitials="businessProfile.businessName[0] || ''"/>
              <v-list-item-content>
                <v-list-item-title>{{ businessProfile.businessName }}</v-list-item-title>
                <v-list-item-subtitle
                >
                  <v-icon class="grey--text" size="14">mdi-map-marker</v-icon>
                  {{ businessProfile.country }}
                </v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action v-if="loggedInUsersPermissions.length > 1">
                <v-icon size="20" color="grey lighten-1">mdi-radiobox-marked</v-icon>
              </v-list-item-action>
            </v-list-item>
            <template v-for="permission in loggedInUsersPermissions">
              <v-list-item
                  v-if="permission.businessProfileId != userProfile.businessProfileId && permission.businessName != ''"
                  :key="permission.businessProfileId"
                  @click.stop="switchBusinessProfile(permission.businessProfileId)"
              >
                <UserAvatar :usersInitials="permission.businessName[0]"/>
                <v-list-item-content>
                  <v-list-item-title>{{ permission.businessName }}</v-list-item-title>
                  <v-list-item-subtitle
                  >
                    <v-icon class="grey--text" size="14">mdi-map-marker</v-icon>
                    {{ permission.country }}
                  </v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon size="20" color="grey lighten-1">mdi-radiobox-blank</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
          <v-divider></v-divider>
          <v-list nav>
            <v-list-item link @click.stop="handleNewBusinessProfile">
              <v-list-item-icon>
                <v-icon>mdi-briefcase-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>New Business Profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>

      <v-menu v-if="false" offset-y v-model="dashboardMenu" transition="slide-y-transition" content-class="mt-2">
        <template #activator="{ on: onMenu }">
          <v-tooltip bottom>
            <template #activator="{ on: onTooltip }">
              <v-btn v-on="{ ...onMenu, ...onTooltip }" icon class="mr-2" active-class="no-active">
                <v-icon>mdi-chart-box</v-icon>
              </v-btn>
            </template>
            <span>Dashboard</span>
          </v-tooltip>
        </template>
        <v-card width="400">
          <v-card-text>
            <v-card outlined>
              <v-card-text class="pt-0">
                <v-list-item two-line class="pa-0">
                  <div class="v-list-item-content--left-item-width">
                    <v-list-item-content class="pt-0">
                      <v-list-item-title class="font-weight-light title mb-2">{{ planName }}</v-list-item-title>
                      <v-list-item-subtitle class="subheading font-weight-light grey--text"
                      >{{
                          businessProfile.billingPeriod == "yearly" ? "Yearly" : "Monthly"
                        }}
                        Subscription
                      </v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </div>
                  <v-spacer/>
                  <span class="text-right">
                    <v-card
                        min-width="64"
                        min-height="64"
                        dark
                        color="rgba( 241, 95, 49, 0.24)"
                        class="text-center my-2"
                    >
                      <!-- <v-icon size="50">group</v-icon> -->
                      <v-avatar color="transparent" size="64" tile>
                        <v-icon size="36" dark>work</v-icon>
                      </v-avatar>
                    </v-card>
                    <!-- <v-sheet class="v-sheet--offset mx-auto my-2 text-center" color="primary" rounded="rounded-1">
                                        <v-avatar color="primary" size="80" tile>
                                        <v-icon size="54" dark>mdi-truck</v-icon>
                                        </v-avatar>
                                    </v-sheet> -->
                                    </span>
                </v-list-item>
                <v-divider class="mb-2"></v-divider>
                <v-icon
                    class="mr-2"
                    small
                >
                  event
                </v-icon>
                <span class="caption grey--text font-weight-light">Next charge on {{
                    formatDate(businessProfile.nextInvoiceCreationDate.toDate())
                  }}</span>
              </v-card-text>
            </v-card>
            <!-- Start: iOS and Android User Row -->
            <v-row>
              <v-col>
                <v-card outlined>
                  <v-card-text class="pt-0">
                    <div class="font-weight-light display-1 mb-2">
                      {{ noOfIosUsers }}
                    </div>
                    <div class="subheading font-weight-light grey--text">
                      <v-icon
                          class="mr-2 mt-n2"
                      >
                        mdi-apple
                      </v-icon>
                      iOS users
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card outlined>
                  <v-card-text class="pt-0">
                    <div class="font-weight-light display-1 mb-2">
                      {{ noOfAndroidUsers }}
                    </div>
                    <div class="subheading font-weight-light grey--text">
                      <v-icon
                          class="mr-2"
                      >
                        mdi-android
                      </v-icon>
                      Android&nbsp;users
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- End: iOS and Android User Row -->
            <!-- Start: Cardholders and Connections User Row -->
            <v-row>
              <v-col class="my-0 py-0">
                <v-card outlined>
                  <v-card-text class="pt-0">
                    <div class="font-weight-light display-1 mb-2">
                      {{ noOfCardHolders }}
                    </div>
                    <div class="subheading font-weight-light grey--text">
                      <v-icon
                          class="mr-2 mt-n2"
                      >
                        group
                      </v-icon>
                      Team Members
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col class="my-0 py-0">
                <v-card outlined>
                  <v-card-text class="pt-0">
                    <div class="font-weight-light display-1 mb-2">
                      {{ noOfConnections }}
                    </div>
                    <div class="subheading font-weight-light grey--text">
                      <v-icon
                          class="mr-2"
                      >
                        share
                      </v-icon>
                      Connections
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- Start: Cardholders and Connections User Row -->
          </v-card-text>
          <v-divider></v-divider>
          <div class="pa-2">
            <v-btn @click="$router.push('/')" block text large>
              <div class="primary--text">View Dashboard</div>
            </v-btn>
          </div>
          </v-card-text>
        </v-card>
        </v-col>
        <v-col>
          <v-card outlined>
            <v-card-text class="pt-0">
              <div class="font-weight-light display-1 mb-2">
                {{ noOfAndroidUsers }}
              </div>
              <div class="subheading font-weight-light grey--text">
                <v-icon class="mr-2">
                  mdi-android
                </v-icon>
                Android&nbsp;users
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        </v-row>
        <!-- End: iOS and Android User Row -->
        <!-- Start: Cardholders and Connections User Row -->
        <v-row>
          <v-col class="my-0 py-0">
            <v-card outlined>
              <v-card-text class="pt-0">
                <div class="font-weight-light display-1 mb-2">
                  {{ noOfCardHolders }}
                </div>
                <div class="subheading font-weight-light grey--text">
                  <v-icon class="mr-2 mt-n2"> group</v-icon>
                  Cardholders
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="my-0 py-0">
            <v-card outlined>
              <v-card-text class="pt-0">
                <div class="font-weight-light display-1 mb-2">
                  {{ noOfConnections }}
                </div>
                <div class="subheading font-weight-light grey--text">
                  <v-icon class="mr-2">
                    share
                  </v-icon>
                  Connections
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- Start: Cardholders and Connections User Row -->
        </v-card-text>
        <v-divider></v-divider>
        <div class="pa-2">
          <v-btn @click="$router.push('/')" block text large>
            <div class="primary--text">View Dashboard</div>
          </v-btn>
        </div>
        </v-card>
      </v-menu>

      <HandleNotification
          :present="presentHandleNotificationComponent"
          :selectedNotification="selectedNotification"
          @handled="presentHandleNotificationComponent = false"
      />
      <v-menu offset-y v-model="recentNotificationsMenu" transition="slide-y-transition" content-class="mt-2">
        <template #activator="{ on: onMenu }">
          <v-tooltip bottom>
            <template #activator="{ on: onTooltip }">
              <v-btn v-on="{ ...onMenu, ...onTooltip }" icon class="mr-2" active-class="no-active">
                <v-badge v-if="businessPortalStats.isNewNotifications" color="primary" overlap dot>
                  <v-icon>mdi-bell</v-icon>
                </v-badge>
                <v-icon v-else>mdi-bell</v-icon>
              </v-btn>
            </template>
            <span>Notifications</span>
          </v-tooltip>
        </template>
        <v-card width="500">
          <v-list v-if="isLoadingRecentNotifications" min-height="375">
            <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
            <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
            <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
            <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
            <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
          </v-list>
          <v-list v-else-if="recentNotifications != 0" nav min-height="375">
            <v-list-item
                v-for="notification in recentNotifications"
                :key="notification.notificationId"
                link
                @click.stop="handleNotificationClick(notification)"
            >
              <UserAvatar
                  :usersInitials="getInitials(notification.userName)"
                  :uid="notification.uid"
                  :businessCardId="notification.businessCardId"
              />
              <v-list-item-content>
                <v-list-item-title style="white-space: normal;">{{ notification.subject }}</v-list-item-title>
                <v-list-item-subtitle
                >
                  <timeago :datetime="Date.parse(notification.createdOn)" :auto-update="60"></timeago
                  >
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="!notification.isRead">
                <v-btn icon>
                  <v-badge dot></v-badge>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-sheet v-else height="375">
            <v-row class="fill-height" align="center" justify="center">
              <v-card elevation="0">
                <v-card-text>
                  <div class="text-center">
                    <v-icon color="grey lighten-2" size="85">mdi-bell</v-icon>
                  </div>
                  <div class=" mt-2 text-center text--primary text-h6 font-weight-regular">
                    No notifications yet
                  </div>
                  <div class="text-center">
                    Stay tuned! Notifications about your activity will show up here.
                  </div>
                </v-card-text>
              </v-card>
            </v-row>
          </v-sheet>
          <v-divider></v-divider>
          <div class="pa-2">
            <v-btn
                :disabled="isLoadingRecentNotifications || recentNotifications.length < 5"
                @click="$router.push('/notifications')"
                block
                text
                large
            >
              <div
                  :class="
                  isLoadingRecentNotifications || recentNotifications.length < 5 ? 'text--disabled' : 'primary--text'
                "
              >
                View All
              </div>
            </v-btn
            >
          </div>
        </v-card>
      </v-menu>
      <v-menu
          :close-on-content-click="false"
          v-model="menu"
          offset-y
          transition="slide-y-transition"
          content-class="mt-2"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon large v-bind="attrs" v-on="on" class="mr-1">
            <v-avatar size="42px" item color="rgba(255, 255, 255, 0.16)">
              {{ userProfile.firstName[0] + userProfile.lastName[0] }}
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <UserAvatar :usersInitials="userProfile.firstName[0] + userProfile.lastName[0]" :uid="loggedInUsersUid"/>
              <v-list-item-content>
                <v-list-item-title>{{ userProfile.firstName }} {{ userProfile.lastName }}</v-list-item-title>
                <v-list-item-subtitle>{{ usersEmail }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list nav>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>nights_stay</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Dark Mode</v-list-item-title>
              <v-list-item-action>
                <v-switch @change="toggleDarkMode" v-model="darkModeSwitch" color="primary" class="pr-10"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
                v-if="currentPermission.privilegeLevel == 'admin'"
                @click="
                menu = false;
                $router.push('/accountSettings');
              "
            >
              <v-list-item-icon>
                <v-icon>mdi-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Account Settings</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
             v-if="currentPermission.privilegeLevel == 'admin'"
             @click="
               menu = false;
               $router.push('/manageSubscription');
             "
           >
             <v-list-item-icon>
               <v-icon>mdi-calendar-cursor</v-icon>
             </v-list-item-icon>
             <v-list-item-content>
               <v-list-item-title>Manage Subscription</v-list-item-title>
             </v-list-item-content>
           </v-list-item> -->
            <v-list-item
                link
                @click.stop="
                menu = false;
                logoutConfirmationDialog = true;
              "
            >
              <v-list-item-icon>
                <v-icon>exit_to_app</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-dialog v-model="logoutConfirmationDialog" max-width="410">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>

        <v-card-text>
          <p class="text-subtitle-1">
            Please confirm you want to log out and end your session.
          </p>
          <v-btn class="mt-10 text-body-1" large elevation="0" color="primary" block @click="logoutUser">
            Log Out
          </v-btn>

          <v-btn
              class="mt-2 text-body-1"
              large
              text
              elevation="0"
              color="primary"
              block
              @click="logoutConfirmationDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <AddEditBusinessCardDialog
      v-model="addEditBusinessCardDialog"
      v-if="currentPermission.privilegeLevel == 'admin' || currentPermission.privilegeLevel == 'editor'"
    /> -->
    <!-- Start: Welcome Dialog -->
    <v-dialog v-model="welcomeDialog" persistent max-width="530">
      <v-card>
        <v-card-text>
          <lottie-animation style="width: 12em;" path="welcome_animation.json"/>
          <p class="text-h5 text--primary text-center">Welcome to Pappyon, {{ userProfile.firstName }}!</p>
          <p class="text--secondary text-center">
            Thanks for creating your account, it’s so exciting to have you and your business a part of the Pappyon
            community.
          </p>
          <p class="text--secondary text-center">
            To get started, let’s help you set up your ConnectionCard to issue to your team members. Click below
            to make this happen in just a few steps.
          </p>
          <v-btn
              class="mt-10 text-body-1"
              large
              elevation="0"
              color="primary"
              block
              to="/manageBusinessProfile"
              @click="welcomeDialog = false"
          >
            Let's set up
          </v-btn>

          <v-btn class="mt-2 text-body-1" large text elevation="0" color="primary" block @click="welcomeDialog = false">
            I’d like to set up later
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End: Welcome Dialog -->
    <v-main>
      <slot/>
      <v-menu
          v-if="
          (currentPermission.privilegeLevel == 'admin' || currentPermission.privilegeLevel == 'editor') &&
            onboadingProgress != 100 && !isCreatingOrEditingMultiConnect
        "
          v-model="onboardingMenu"
          transition="slide-y-transition"
          top
          :offset-y="true"
          content-class="menu-offset-class mr-5"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark depressed color="secondary" fixed large rounded right bottom v-bind="attrs" v-on="on">
            <v-badge color="primary" :content="remainingTasks">
              <v-icon dark class="mr-2">mdi-clipboard-check-outline</v-icon>
              Let's set up
            </v-badge>
          </v-btn>
        </template>
        <v-card>
          <div class="px-4 py-4">
            <div class="font-weight-regular text-body-1">
              {{
                isPartnerRepresentative() ? "Finish setting up your business details for the event" : "Finish setting up your business card"
              }}
            </div>
            <div class="text-body-2 font-weight-light grey--text">
              Give your connections a great impression of your business.
            </div>
            <div class="text-center my-2 font-weight-regular text-h6 text--secondary">{{ onboadingProgress }}%</div>
            <v-progress-linear rounded :value="onboadingProgress"></v-progress-linear>
          </div>
          <v-divider class="mx-4"></v-divider>
          <v-list nav dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-check-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-decoration-line-through">Create your account</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
                v-on="{
                click: isBusinessCardInformationAdded ? null : addBusinessContactDetailsClicked,
              }"
            >
              <v-list-item-icon>
                <v-icon v-if="isBusinessCardInformationAdded" color="primary">mdi-check-circle</v-icon>
                <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                    :class="{
                    'text-decoration-line-through': isBusinessCardInformationAdded,
                  }"
                >Add business contact details
                </v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item
                v-on="{
                click: isBusinessCardDesignAdded ? null : addBusinessCardDesignClicked,
              }"
            >
              <v-list-item-icon>
                <v-icon v-if="isBusinessCardDesignAdded" color="primary">mdi-check-circle</v-icon>
                <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                    :class="{
                    'text-decoration-line-through': isBusinessCardDesignAdded,
                  }"
                >Add branding to your business card
                </v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item
                v-on="{
                click: businessProfile.noOfEmployees == noOfCardHolders ? null : issueBusinessCardClicked,
              }"
            >
              <v-list-item-icon>
                <v-icon v-if="businessProfile.noOfEmployees == noOfCardHolders" color="primary">mdi-check-circle
                </v-icon>
                <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                    :class="{
                    'text-decoration-line-through': businessProfile.noOfEmployees == noOfCardHolders,
                  }"
                >{{ businessProfile.noOfEmployees == 1 ? "Add Team Member" : "Add Team Members" }}
                </v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>

      <AddEditPaymentMethodDialog v-if="showUpdatePaymentMethodDialog" :show="showUpdatePaymentMethodDialog"
                                  @close="showUpdatePaymentMethodDialog = false"/>
    </v-main>
  </v-app>
</template>
<script>

import {mapGetters, mapActions} from "vuex";
import UserAvatar from "@/components/UserAvatar";
import NotificationUtility from "@/shared/notification-utility";
import Utility from "@/shared/utility";
import HandleNotification from "@/components/HandleNotification";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
// import AddEditBusinessCardDialog from "@/components/AddEditBusinessCardDialog";
import LinkInBio from "@/models/LinkInBio";
import AddEditPaymentMethodDialog from "@/components/ManageSubscription/AddEditPaymentMethodDialog";

import {onSnapshot, where, orderBy, limit} from "firebase/firestore";
import {
  businessPortalStatsDocRef,
  businessProfilesDocRef,
  getDocRef, getHttpsCallable,
  getQueryBusinessPortalNotificationsCollection,
  getAuth,
  getQueryByCollectionName,
  queryBusinessCardsCollection,
  queryBusinessProfilesCollection, queryByCollectionName, queryEventCollection
} from "@/shared/firebase_utils";

export default {
  async created() {
    this.formatDate = Utility.formatDate;
    this.getSubscriptionPlanTitle = Utility.getSubscriptionPlanTitle;
    this.usersEmail = getAuth().currentUser.email;
    this.$vuetify.theme.dark = this.userProfile.isDarkMode || false;

    this.unsubscribeBusinessPortalStats = onSnapshot(businessPortalStatsDocRef(this.userProfile.businessProfileId), (doc) => {
      this.onBusinessPortalStatsSnapshot(doc.data());
    });
    this.clearCardholders();

    this.unsubscrbeCardHoldersSnapshot = onSnapshot(queryBusinessCardsCollection(where("businessProfileId", "==", this.userProfile.businessProfileId)),
        (response) => {
          const changes = response.docChanges();
          this.onCardHoldersSnapshot(changes);
        });
    this.displayWelcomeDialog();

    this.unsubscribeBusinessProfile = onSnapshot(businessProfilesDocRef(this.userProfile.businessProfileId),
        (doc) => {
          this.onBusinessProfileSnapshot(doc.data());
        });

    //Start: Link-in-bio snapshot
    this.unsubscribeLinkInBioSnapshot = onSnapshot(queryByCollectionName("link_in_bio", where("businessProfileId", "==", this.userProfile.businessProfileId)), (response) => {
          const change = response.docChanges()[0];
          let linkInBio;
          if (change != undefined || change != null)
            linkInBio = LinkInBio.fromFireStore(change.doc.data());
          else
            linkInBio = new LinkInBio({
              businessProfileId: this.userProfile.businessProfileId,
            });
          if (linkInBio?.id == "") {
            //Split legal options from business name
            let businessName = this.businessProfile.businessName
                .toLowerCase()
                .split("pty ltd")[0]
                .trim();

            businessName = businessName.replace(/[^a-zA-Z0-9 ]/g, "");

            console.log("businessName: ", businessName);

            this.linkInBioIdentifier = businessName.split(" ").join("");
            this.businessName = businessName.split(" ").join("");
            //Generate identifier
            this.generateIdentifier(this.linkInBioIdentifier);

            try {
              this.updateBusinessProfileDetails({
                linkWithPappyonURL: this.linkInBio.id,
              });
            } catch (error) {
              console.log(
                  "Error occurred while updating link with pappyon in business profile: ",
                  error
              );
            }
          }
          this.setLinkInBio(linkInBio);
          let deepCloneLinkInBio = JSON.parse(JSON.stringify(linkInBio));
          let customObj = LinkInBio.fromFireStore(deepCloneLinkInBio);
          this.setTransientLinkInBio(customObj);
        });
    //End: Link-in-bio snapshot



    if (this.isSuperUser) {
      //Start: Snapshot for business profiles
      try {
        this.unsubscribeBusinessProfilesSnapshot = onSnapshot(
                queryBusinessProfilesCollection(where("businessName", ">", "")),
                (response) => {
              const changes = response.docChanges();
              this.onBusinessProfilesSnapshot(changes);
            });
      } catch (error) {
        console.log(
            "Error occurred while fetching business profile for super user: ",
            error
        );
      }
      //End: Snapshot for business profiles

      try {
        this.unsubscribeEventsSnapshot = onSnapshot(
              queryEventCollection(),
            (querySnapshot) => {
              const changes = querySnapshot.docChanges();

              this.onMultiConnectEventsSnapshot(changes);
            });
      } catch (error) {
        console.log(
            "Error occurred while fetching snapshot of events for super user: ",
            error
        );
      }
    } else {
          // .where("eventCategory", "==", "multiConnect")
      this.unsubscribeEventsSnapshot =
          onSnapshot(
              queryEventCollection(where("businessProfileId", "==", this.userProfile.businessProfileId)),
              (querySnapshot) => {
            const changes = querySnapshot.docChanges();

            this.onMultiConnectEventsSnapshot(changes);
          });
    }
  },
  destroyed() {
    this.unsubscrbeCardHoldersSnapshot();
    this.clearCardholders();
    this.unsubscribeBusinessPortalStats();
    this.unsubscribeBusinessProfile();
    this.unsubscribeLinkInBioSnapshot();
    this.unsubscribeEventsSnapshot();
    this.clearMultiConnectEvents();
    this.unsubscribeBusinessProfilesSnapshot();
  },
  data() {
    return {
      loadingDialog: false,
      loadingMessage: "",
      presentHandleNotificationComponent: false,
      selectedNotification: {},
      businessProfilesMenu: false,
      dashboardMenu: false,
      recentNotificationsMenu: false,
      darkModeSwitch: false,
      recentNotifications: [],
      isLoadingRecentNotifications: false,
      unsubscribeBusinessPortalStats: null,
      unsubscrbeCardHoldersSnapshot: null,
      drawer: true,
      logoutConfirmationDialog: false,
      usersEmail: "",
      menu: false,
      onboardingMenu: false,
      welcomeDialog: false,
      addEditBusinessCardDialog: false,
      totalTasks: 4,
      unsubscribeBusinessProfile: null,
      unsubscribeEvents: null,
      unsubscribeLinkInBioSnapshot: null,
      count: 0,
      linkInBioIdentifier: "",
      businessName: "",
      unsubscribeEventsSnapshot: null,
      unsubscribeBusinessProfilesSnapshot: null,

      optionalInclusions: [
        {
          title: "EventConnect",
          icon: "mdi-account-group",
          link: "/multiConnect",
        },
        {
          title: "CRM Integration",
          icon: "mdi-puzzle",
          link: "/crmIntegration",
        },
      ],
      showUpdatePaymentMethodDialog: false,
    };
  },
  components: {
    UserAvatar,
    HandleNotification,
    LottieAnimation,
    AddEditPaymentMethodDialog,
    // AddEditBusinessCardDialog,
  },
  computed: {
    ...mapGetters([
      "userProfile",
      "businessProfile",
      "businessPortalStats",
      "loggedInUsersUid",
      "loggedInUsersPermissions",
      "currentPermission",
      "noOfConnections",
      "noOfCardHolders",
      "noOfDeactiveCardHolders",
      "noOfIosUsers",
      "noOfAndroidUsers",
      "supportUrl",
      "transientLinkInBio",
      "linkInBio",
      "multiConnectEvents",
      "isSuperUser",
    ]),
    isDarkModeActivated: function () {
      return this.$vuetify.theme.dark;
    },
    planName() {
      return this.getSubscriptionPlanTitle(this.businessProfile.plan);
    },
    items() {
      let value = [
        {title: "Dashboard", icon: "mdi-home", link: "/"},
        {title: "Your Card", icon: "crop_16_9", link: "/manageCard"},
        {title: "Manage Team", icon: "people", link: "/cardholders"},
        /*        {
                  title: "Link with Pappyon",
                  icon: "mdi-link-variant",
                  link: "/linkWithPappyon",
                },*/
        {
          title: "Your Business Network",
          icon: "mdi-account-network",
          link: "/yourBusinessNetwork"
        }
        // {
        //   title: "Notifications",
        //   icon: "mdi-bell-ring",
        //   link: "/notifications",
        // },

        //  { title: 'Industry Specific Profile', icon: 'mdi-domain', link: '/industrySpecificProfile'},
        //   { title: 'Pappyon Premiere', icon: 'bookmark_border', link: '/pappyonPremiere'},
      ];
      //Uncomment after demo
      // value.push({
      //   title: "Multi Connect",
      //   icon: "mdi-account-group",
      //   link: "/multiConnect",
      // });
      if (this.currentPermission.privilegeLevel == "admin") {
        value.push({
          title: "Manage Subscription",
          icon: "mdi-calendar-cursor",
          link: "/manageSubscription",
        });
      }
      value.push({
        title: "Administration",
        icon: "mdi-shield-account-variant",
        link: "/administration",
      });
      //Start: Add super user route

      if (
          this.usersEmail == "son@pappyon.com" ||
          this.usersEmail == "yash@pappyon.com"
      ) {
        value.push({
          title: "Analytics",
          icon: "mdi-google-analytics",
          link: "/analytics-dashboard",
        });
      }
      if (this.isPartnerRepresentative()) {
        value = [
          {title: "Dashboard", icon: "mdi-home", link: "/"},
          {title: "Your Card", icon: "crop_16_9", link: "/manageCard"},
          {title: "Manage Team", icon: "people", link: "/cardholders"},
          {title: "Your Events", icon: "mdi-account-group", link: "/yourEvents"},
          {title: "Administration", icon: "mdi-shield-account-variant", link: "/administration"}
        ];
      }
      return value;
    },
    isBusinessCardInformationAdded() {
      return (
          this.businessProfile.isBusinessCardInformationAdded == undefined ||
          this.businessProfile.isBusinessCardInformationAdded == true
      );
    },
    isBusinessCardDesignAdded() {
      return (
          this.businessProfile.isBusinessCardDesignAdded == undefined ||
          this.businessProfile.isBusinessCardDesignAdded == true
      );
    },
    onboadingProgress() {
      return (this.compltedTasks / this.totalTasks) * 100;
    },
    compltedTasks() {
      let compltedTasks = 1;
      if (this.isBusinessCardInformationAdded) compltedTasks++;
      if (this.isBusinessCardDesignAdded) compltedTasks++;
      if (this.businessProfile.noOfEmployees == this.noOfCardHolders)
        compltedTasks++;
      return compltedTasks;
    },
    remainingTasks() {
      return this.totalTasks - this.compltedTasks;
    },
    isCreatingOrEditingMultiConnect() {
      if (
          this.$route.name == "addMultiConnect" ||
          this.$route.name == "editMultiConnect" ||
          this.$route.name == "addEditSubEvent" ||
          this.$route.name == "addEditSession"
      )
        return true;
      else return false;
    },
  },
  watch: {
    isDarkModeActivated: function (newVal, oldVal) {
      this.darkModeSwitch = newVal;
    },
    recentNotificationsMenu: function (newVal, oldVal) {
      if (oldVal == false && newVal == true) this.loadRecentNotifications();
    },
    remainingTasks: function (newVal, oldVal) {
      if (newVal != 0) {
        if (
            this.businessProfile.noOfEmployees != this.noOfCardHolders &&
            this.noOfDeactiveCardHolders > 0
        )
            //If the Issue business cards is unchecked but the noOfDeactiveCardHolders is greater than zero
          this.onboardingMenu = false;
        else this.onboardingMenu = true;
      }
    },
  },
  methods: {
    ...mapActions([
      "onBusinessPortalStatsSnapshot",
      "onCardHoldersSnapshot",
      "clearCardholders",
      "updateUserProfileDetails",
      "updateSelectedBusinessProfileId",
      "resetIsNewNotifications",
      "updateBusinessProfileDetails",
      "onBusinessProfileSnapshot",
      "setLinkInBio",
      "setTransientLinkInBio",
      "onMultiConnectEventsSnapshot",
      "clearMultiConnectEvents",
      "setCurrentEvent",
      "onBusinessProfilesSnapshot",
      "showSnackbar",
    ]),
    isPartnerRepresentative() {
      if (this.businessProfile.partnerRepresentativeToken) {
        return true;
      } else {
        return false;
      }
    },
    issueBusinessCardClicked() {
      this.$router.push("cardholders");
    },
    addBusinessContactDetailsClicked() {
      this.$router.push("/manageBusinessProfile");
    },
    addBusinessCardDesignClicked() {
      this.$router.push("cardDesign");
      // this.addEditBusinessCardDialog = true;
    },
    async restartSubscription() {
      this.loadingMessage = "Restarting your subscription...";
      this.loadingDialog = true;
      try {
        //Call a cloud function to cancel the subscription
        const setSubscriptionAutoRenewal = getHttpsCallable("setSubscriptionAutoRenewal");
        const response = await setSubscriptionAutoRenewal({
          subscriptionId: this.businessProfile.subscriptionId,
          email: this.userProfile.email,
          firstName: this.userProfile.firstName,
          cancelAtPeriodEnd: false,
          plan: this.businessProfile.plan,
          quantity: this.businessProfile.noOfEmployees,
        });
        await this.updateBusinessProfileDetails({
          subscriptionStatus: response.data.cancelAtPeriodEnd,
        });
        this.loadingDialog = false;
        // await firebase.auth().signOut();
        // this.$router.push("/login");
      } catch (error) {
        console.log(error);
        this.loadingDialog = false;
        this.showSnackbar({
          show: true,
          text: "Error occurred, please try again!",
        });
      }
    },
    async displayWelcomeDialog() {
      if (
          !(
              this.currentPermission.privilegeLevel == "admin" ||
              this.currentPermission.privilegeLevel == "editor"
          )
      )
        return;
      let isBusinessPortalOnboarded =
          this.businessProfile.isBusinessPortalOnboarded;
      if (isBusinessPortalOnboarded == undefined)
        isBusinessPortalOnboarded = true;
      if (!isBusinessPortalOnboarded) {
        this.welcomeDialog = true;
        await this.updateBusinessProfileDetails({
          isBusinessPortalOnboarded: true,
        });
      }
    },
    async toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      await this.updateUserProfileDetails({
        isDarkMode: this.$vuetify.theme.dark,
      });
    },
    openSupportUrl() {
      window.open(this.supportUrl);
    },
    async logoutUser() {
      this.logoutConfirmationDialog = false;
      getAuth()
          .signOut()
          .then(async () => {
            this.$vuetify.theme.dark = false;
            // Sign-out successful.
            window.location.reload();
          })
          .catch(function (err) {
            // An error happened.
            console.log(err);
          });
    },
    async loadRecentNotifications() {
      this.resetIsNewNotifications();
      this.isLoadingRecentNotifications = true;
      this.recentNotifications = [];
      try {
        let querySnapshot = await getQueryBusinessPortalNotificationsCollection(
            where("businessProfileId", "==", this.userProfile.businessProfileId),
            orderBy("createdOn", "desc"),
            limit(5));
        querySnapshot.forEach((documentRef) => {
          let data = documentRef.data({serverTimestamps: "estimate"});
          let document = {
            ...data,
            displayImageUrl: "",
            subject: NotificationUtility.formatNotificationSubject(data),
            type: data.type,
            createdOn: data.createdOn.toDate(),
            businessCardId: data.businessCardId,
            uid: data.uid,
            userName: data.userName,
            notificationId: documentRef.id,
            isRead: data.isRead,
          };

          if (document.subject != "") this.recentNotifications.push(document);
        });
      } catch (error) {
        console.log(error);
      }
      this.isLoadingRecentNotifications = false;
    },
    getInitials(name) {
      return Utility.getInitials(name);
    },
    async handleNewBusinessProfile() {
      this.$router.push({name: "BusinessAccounts", query: {create: true}});
    },
    async switchBusinessProfile(switchToBusinessProfileId) {
      this.$router.push({
        name: "BusinessAccounts",
        query: {switchToBusinessProfileId: switchToBusinessProfileId},
      });
    },
    handleNotificationClick(item) {
      this.recentNotificationsMenu = false;
      this.selectedNotification = item;

      //Start: Redirect to view registrants page for multi connect
      if (item.type == "MULTICONNECT_ATTENDEE_JOINED") {
        let multiConnectEvent = this.multiConnectEvents.find(
            (event) => event.id == item.multiConnectEventId
        );

        this.setCurrentEvent(multiConnectEvent);

        this.$router.push({
          name: "editMultiConnect",
          params: {eventId: multiConnectEvent.id},
          query: {tab: 4},
        });
      }
      //End: Redirect to view registrants page for multi connect

      this.presentHandleNotificationComponent = true;
    },
    generateIdentifier(identifier) {
      const linkInBioRef = getDocRef("link_in_bio", identifier)
      linkInBioRef.get().then((docSnapshot) => {
        //If identifier is not available, append counter value to it
        if (docSnapshot.exists) {
          this.count = this.count + 1;
          // this.linkInBioIdentifier = this.linkInBioIdentifier.split(" ").join("") + this.count;
          this.linkInBioIdentifier =
              this.businessName.split(" ").join("") + this.count;

          this.generateIdentifier(this.linkInBioIdentifier);
        } else {
          this.transientLinkInBio.id = identifier.split(" ").join("");
          this.linkInBio.id = identifier.split(" ").join("");
        }
      });
    },
  },
};
</script>
<style scoped>
.v-btn--active.no-active::before {
  opacity: 0 !important;
}

.menu-offset-class {
  margin: -20px 0 0 0;
}

.warning-icon-size {
  font-size: 18px !important;
}

.system-bar-canceled-subscription {
  color: #4b687b;
}

.charcoal-grey-text {
  color: #212121;
}
</style>